import createAction from "../app/createAction.js";
import {
    AUTH_REGISTER_MOBILE_APP_ACTION,
    AUTH_REGISTER_MOBILE_APP_FAILURE,
    AUTH_REGISTER_MOBILE_APP_SUCCESS,
    AUTH_VERIFY_MOBILE_APP_ACTION,
    AUTH_VERIFY_MOBILE_APP_FAILURE,
    AUTH_VERIFY_MOBILE_APP_SUCCESS,
    CLOSE_MOBILE_SLIDER_PAGE,
    OPEN_MOBILE_SLIDER_PAGE,
    REGISTRATION_PREPARE_MOBILE_ACTION,
    REGISTRATION_START_MOBILE_ACTION,
} from "./mobileAppConstants.js";

export const openMobileSliderPageAction = (payload) => createAction(OPEN_MOBILE_SLIDER_PAGE, payload);
export const closeMobileSliderPageAction = (payload) => createAction(CLOSE_MOBILE_SLIDER_PAGE, payload);

export const registrationPrepareMobileAction = (payload) => createAction(REGISTRATION_PREPARE_MOBILE_ACTION, payload);
export const registrationStartMobileAction = (payload) => createAction(REGISTRATION_START_MOBILE_ACTION, payload);

export const authRegisterMobileAppAction = (payload) => createAction(AUTH_REGISTER_MOBILE_APP_ACTION, payload);
export const authRegisterMobileAppSuccess = (payload) => createAction(AUTH_REGISTER_MOBILE_APP_SUCCESS, payload);
export const authRegisterMobileAppFailure = (payload) => createAction(AUTH_REGISTER_MOBILE_APP_FAILURE, payload);

export const authVerifyMobileAppAction = (payload) => createAction(AUTH_VERIFY_MOBILE_APP_ACTION, payload);
export const authVerifyMobileAppSuccess = (payload) => createAction(AUTH_VERIFY_MOBILE_APP_SUCCESS, payload);
export const authVerifyMobileAppFailure = (payload) => createAction(AUTH_VERIFY_MOBILE_APP_FAILURE, payload);
